
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"matrix(2,0,0,2,0,0)"}},[_c('g',[_c('path',{staticStyle:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"},attrs:{"d":"M13.75,4.54a1.5,1.5,0,0,0-.95-1.39,1.48,1.48,0,0,0-1.65.38L5.69,9.44a1.49,1.49,0,0,0,0,2l5.46,5.92a1.5,1.5,0,0,0,2.6-1V13.46h2a7.5,7.5,0,0,1,7.5,7.5V15a7.5,7.5,0,0,0-7.5-7.5h-2Z"}}),_c('path',{staticStyle:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"},attrs:{"d":"M6.61,3.53,1.15,9.44a1.49,1.49,0,0,0,0,2l5.46,5.92"}})])])])
          )
        }
      }
    